// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"fbd04dd1"};